import { Tools, Type, Watermark } from 'me-view/lib/script/index'
import Message from 'me-view/lib/message'
import util from '@common/util'
import action from '@common/action'

function verifyRoute (to) {
  loadWatermark(to.path)
  if (util.ownMenu(to.path) === false) {
    console.debug('登录者没有:', to.path, ' 访问权限...')
    Message.warning('无权访问')
    return false
  }
  util.synchronizeSession(/** 通知其他系统同步会话 */)
  return true
}
const watermark = new Watermark()
function loadWatermark (path) {
  console.debug('Router -------> 添加水印...')
  if (util.ignoringWatermark(path) === true) { return }
  const userInfo = util.userInfo
  if (userInfo) {
    console.debug('Router -------> 添加水印，获取当前登录信息...', userInfo)
    const { code, name } = userInfo || {}
    watermark.init(`${name} (${code})`)
  }
}

export default async (to, from, next) => {
  // 调试模式
  const __debug = to.query.__debug
  if (__debug === 'true') {
    console.warn('程序开启debugger模式...')
    debugger
  }

  if (util.ignoringRoute(to.path) === true) {
    console.debug('Router -------> 忽略路由，则取消鉴权...')
    loadWatermark(to.path)
    return next(true)
  }

  if (Tools.notEmpty(util.authorization)) {
    // 路由鉴权
    await action.loadSystemDict(/* 加载数据字典 */)
    return next(verifyRoute(to))
  }

  // console.debug('未获取到token信息，程序开始验证portal_token信息...');
  const token = to.query.token
  if (Type.notString(token)) {
    console.debug(`菜单请求参数：token = ${token}`)
    util.systemLogout()
    return next(false)
  }

  util.userInfo = await action.loginToken({ token })
  await action.loadSystemDict(/* 加载数据字典 */)
  return next(verifyRoute(to))
}
